import React, { Component } from 'react';
import { isEmpty, size } from "lodash";
import { Box, Typography, Dialog, DialogContent, IconButton, Table, TableBody, TableCell, TableRow, AppBar, Toolbar, TableHead, TableFooter, TablePagination  } from '@mui/material';
import Currency from '../../../common/Currency';
import Pagination from '../../../../container/MUI/Pagination';
import SpendingDetails from '../../../Spendings/SpendingDetails';
import TitleWithEndAction from '../../../common/TitleWithEndAction';

class EquipementSpendings extends Component {
    state = { 
        page: 0,
        rowsPerPage: 10,
        spendings: [],
        total: 0,
        totalDu: 0,
        openDetails: false, 
        selectedSpending: {}
    }
    componentDidMount = async () => {
        this.filterSpendings()
    }
    handleChangePage = (event, page) => {
        this.setState({ page });
    };

    handleChangeRowsPerPage = event => {
        this.setState({ page: 0, rowsPerPage: parseInt(event.target.value) });
    };


    filterSpendings = () => {
        const { SPENDINGS, equipement, eType } = this.props;
        let filteredList = !isEmpty(SPENDINGS) ? Object.values(SPENDINGS).filter(item => item[`spending_${eType}`] === equipement.equipement_id) : []
        
        console.log('====================================');
        console.log({filteredList});
        console.log('====================================');
        let total = 0
        let totalDu = 0
        filteredList.forEach(item => {
            total += item.spending_amountTTC;
            totalDu += item.spending_rest_to_pay
        })

        this.setState({
            spendings: filteredList,
            total,
            totalDu,
        })
    }
    displaySpendings = () => {
        const { rowsPerPage, page, spendings } = this.state;
        const { CATEGORIES } = this.props;
        
        return spendings.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map( item => {
            let category = CATEGORIES.CHILD[item.spending_category]
            // let user = isEmpty(USERS) ? {} : USERS[item.spending_user]
            // let labels = LABELS && item.spending_labels && this.displayLabels(item.spending_labels)
            // let supplier = isEmpty(SUPPLIERS) ? {} : SUPPLIERS[item.spending_supplier]

            return (
                <TableRow 
                    hover
                    key={item.spending_id}
                    onClick={() => this.setState({openDetails: true, selectedSpending: item }) }
                >
                    <TableCell >{new Date(item.spending_date).toLocaleDateString('fr-FR')}</TableCell>
                    <TableCell >{ category && category.category_name}</TableCell>                     
                    <TableCell>{item.spending_desc}</TableCell>   
                    <TableCell><Currency value={item.spending_amountTTC} /></TableCell>                     
                    <TableCell>
                        {!item.spending_fully_paid &&
                            <Currency value={item.spending_rest_to_pay} />
                        }
                    </TableCell>                     
                </TableRow>
            )
        })
    }
    render() {
        const { supplier, CATEGORIES, BANKS, PAYMENTS, LABELS } = this.props;
        const { spendings, rowsPerPage, page, total, totalDu, openDetails, selectedSpending} = this.state;
        return (
            <Box>

                {openDetails && selectedSpending && 
                    <SpendingDetails 
                        supplier={supplier} 
                        LABELS={LABELS}
                        BANKS={BANKS}
                        PAYMENTS={PAYMENTS}
                        category={CATEGORIES.CHILD && CATEGORIES.CHILD[selectedSpending.spending_category]} 
                        spending={selectedSpending} 
                        view={"ADMIN"}
                        handleClose={()=> this.setState({openDetails: false, selectedSpending: {}})}
                        fetchSpendingPayments={this.props.fetchSpendingPayments}
                    />
                }

                <Box p={1}>
                    {/* <TitleWithEndAction
                        title= " "
                        action={() => this.props.openFormCustom(this.props.supplier.supplier_id)}
                    /> */}
                    <Table>
                        <TableHead>
                            <TableRow>
                                <TableCell>Créé le</TableCell>
                                <TableCell>Catégorie</TableCell>
                                <TableCell>Description</TableCell>
                                <TableCell>Montant TTC</TableCell>
                                <TableCell>Reste à Payer</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {!isEmpty(spendings) && !isEmpty(CATEGORIES.CHILD) && this.displaySpendings()}
                        </TableBody>
                        {size(spendings) > 10 &&
                            <TableFooter>
                                <TableRow>
                                    <TablePagination
                                        rowsPerPageOptions={[10, 30]}
                                        labelRowsPerPage="Lignes par Page"
                                        colSpan={5}
                                        count={size(spendings)}
                                        rowsPerPage={rowsPerPage}
                                        page={page}
                                        SelectProps={{
                                            native: true,
                                        }}
                                        onPageChange={this.handleChangePage}
                                        onRowsPerPageChange={this.handleChangeRowsPerPage}
                                        ActionsComponent={Pagination}
                                    />
                                </TableRow>
                            </TableFooter>
                        }
                    </Table>
                </Box>
            </Box>
                            
        );
    }
}

export default EquipementSpendings;